import create from 'zustand';
import { immer } from 'zustand/middleware/immer'
import {SortParams} from "@/components/SortIndicator";
import { SortPostParams } from "@/containers/admin/Information/InformationList"

export const InformationListHeader = [
  {
    headerName:'ステータス',
    sortItemName: 'display_drmdx',
  },
  {
    headerName:'表示場所',
    sortItemName: 'display_mypage',
  },
  {
    headerName:'表示期間',
    sortItemName: 'start_date',
  },
  {
    headerName:'タイトル',
    sortItemName: 'title',
  },
  {
    headerName:'お知らせ内容',
    sortItemName: 'details',
  },
  {
    headerName:'最終更新者',
    sortItemName: 'modified_by',
  },
  {
    headerName:'最終更新日時',
    sortItemName: 'modified',
  },
];

const initState = {
  queryParams: undefined,
  childSubmit: () => {
  },
  sortParams: {} as SortParams,
  doSort: () => {
  },
}

type InformationStore = {
  queryParams: SortPostParams | undefined;
  setQueryParams: (any: SortPostParams | undefined) => void;
  sortParams: SortParams;
  setSortParams: (sortParams: SortParams) => void;
  doSort: (sortParams: SortParams) => void;
  setDoSort: (func: InformationStore['doSort']) => void;

};

export const useInformationStore = create<InformationStore>()(
  immer((set) => ({
    ...initState,
    setQueryParams: (queryParams) =>
      set((state) => ({
        queryParams: queryParams,
      })),
    setSortParams: (sortParams) =>
      set((state) => ({
        sortParams: sortParams,
      })),
    setDoSort: (doSort) =>
      set((state) => ({
        doSort: doSort,
      }))
  }))
);
